"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BioentityInformation["default"];
  }
});
exports.render = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _atlasReactFetchLoader = require("@ebi-gene-expression-group/atlas-react-fetch-loader");

var _BioentityInformation = _interopRequireDefault(require("./BioentityInformation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BioentityInformationWithFetchLoader = (0, _atlasReactFetchLoader.withFetchLoader)(_BioentityInformation["default"]);

var render = function render(options, target) {
  _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(BioentityInformationWithFetchLoader, options), document.getElementById(target));
};

exports.render = render;